/* eslint-disable @typescript-eslint/prefer-reduce-type-parameter */
import { Injectable } from '@angular/core';
import { createStore, select, withProps } from '@ngneat/elf';
import { type FeatureConfigDto } from '../models/feature-config-dto.model';
import { type FeatureConfig } from '../models/feature-config.model';
import { featureFlagsArray } from './../models/feature-types';

export const createInitialConfig: (featureConfigDto?: FeatureConfigDto) => FeatureConfig = (featureConfigDto?: FeatureConfigDto): FeatureConfig => {
    const defaultConfig = { featureFlags: {} } as FeatureConfig;

    return featureConfigDto
        ? featureConfigDto.features.reduce<FeatureConfig>((config, flag) => ({
            featureFlags: {
                ...config.featureFlags,
                [flag.name]: flag.enabled,
            },
        }), defaultConfig)
        : featureFlagsArray.reduce<FeatureConfig>((config, flag) => ({
            featureFlags: {
                ...config.featureFlags,
                [flag]: false,
            },
        }), defaultConfig);
}
export const featureFlagsStore = createStore(
    { name: 'featureFlags' },
    withProps<FeatureConfig>(createInitialConfig()),
);

@Injectable({ providedIn: 'root' })
export class FeatureFlagsRepository {
    public state$ = featureFlagsStore.pipe(select(state => state));

    public update(config: FeatureConfig['featureFlags']): void {
        featureFlagsStore.update(state => ({
            featureFlags: {
                ...state.featureFlags,
                ...config,
            },
        }));
    }

    public getValue(): FeatureConfig {
        return featureFlagsStore.getValue();
    }
}
